import { px2remTransformer } from '@ant-design/cssinjs';

const transformers: Array<ReturnType<typeof px2remTransformer>> = [
  px2remTransformer({
    rootValue: 16,
  }),
];

export { transformers };
